import { patientRequestsTyped } from "@/api/(requests)/patientTyped";
import type { UUID } from "@/core/types";

export type RemoveFromWaitListVariables = {
  patientId: UUID;
};

export async function removeFromWaitList({
  patientId,
}: RemoveFromWaitListVariables): Promise<void> {
  await patientRequestsTyped.remove_from_wait_list({
    context: { showLoader: false },
    searchParams: { patient_username: patientId },
  });
}
